import React, { useState, useEffect, useCallback } from 'react';
import './TimeKeeping.css';
import './../../App.css';
import 'react-calendar/dist/Calendar.css'; // Import default calendar stylesheet
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain, globalTimeFormat} from '../Security';
import 'react-tabs/style/react-tabs.css'; 
import loadingSpinner from './../../assets/loading.gif';
import { useTable, useSortBy } from "react-table";
import { format } from 'date-fns';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from '@mui/icons-material/Done';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import SearchIcon from '@mui/icons-material/Search';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChecklistIcon from '@mui/icons-material/Checklist';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const TamperedApproval = ({user, userAccess, isHideSideMenu}) => {
    const [loadingRequest, setLoadingRequest] = useState(false);
    // const [employees, setEmployees] = useState([]);
    const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
    const [selectedDTR, setSelectedDTR] = useState([]);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs
    const [isRevert, setIsRevert] = useState(false);
    const [isProcess, setIsProcess] = useState(false);
    const [isPost, setIsPost] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [isSelectLogs, setIsSelectLogs] = useState(false);

    //filters

    const [filteredPayrollPeriod, setFilteredPayrollPeriod] = useState(null);
    const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
    const [filterClassificationIdTimeEntries, setFilterClassificationIdTimeEntries] = useState("0");
    const [filterClassificationIdTimeEntries2, setFilterClassificationIdTimeEntries2] = useState("2");
    const [filterClassificationIdTimeEntries3, setFilterClassificationIdTimeEntries3] = useState("4");
    
    const [sectionFilter, setSectionFilter] = useState("0");
    const [locationFilter, setLocationFilter] = useState("0");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    const [filterDataIndex, setFilterDataIndex] = useState(4);
    
    const [filterData, setFilterData] = useState([]);

    //====================================================================================================
    //===============================TIME ENTRIES=========================================================
    //====================================================================================================
    // const [isSetEmployeesOnce, setIsSetEmployeesOnce] = useState(false);
    const [showTampered, setShowTampered] = useState(true);
    const [allDTR, setAllDTR] = useState([]);
    const fetchDataTimeEntries = useCallback(async () => {
        let classificationFilter = filterClassificationIdTimeEntries;

        if(userAccess?.description === "Admin" || userAccess?.description === "HR Head" || userAccess?.description === "HR Assistant"){
            classificationFilter = filterClassificationIdTimeEntries;
        } else if(userAccess?.description === "HR Assistant2"){
            classificationFilter = filterClassificationIdTimeEntries2;
        } else if(userAccess?.description === "HR Assistant3"){
            classificationFilter = filterClassificationIdTimeEntries3;
        }
        
        // const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}`;
        const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/tampered/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}`;

        try {
            setLoadingRequest(true);
            const response = await axios.get(apiUrlFetch, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                let filteredBySection = response.data;

                setCurrentClassificationFilter(classificationFilter);

                if(classificationFilter !== currentClassificationFilter){
                    setSectionFilter("0")
                    setLocationFilter("0")
                }

                let finalData = filteredBySection;

                if(filterDataIndex === 3) {
                    finalData = finalData.filter(e => e.isApproved);
                } else if(filterDataIndex === 4) {
                    finalData = finalData.filter(e => !e.isApproved);
                }

                setAllDTR(finalData); // Set the response data to the state
                setDateTimeRecordData(finalData); // Set the response data to the state
                setFilterData(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoadingRequest(false);
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, [
        currentClassificationFilter,
        filterClassificationIdTimeEntries,
        filterClassificationIdTimeEntries2,
        filterClassificationIdTimeEntries3,
        sectionFilter,
        locationFilter,
        userAccess,
        filterDataIndex
    ]);

    useEffect(() => {
        fetchDataTimeEntries();
    }, [fetchDataTimeEntries]);

    useEffect(() => {
        let finalData = allDTR;
        if(filteredPayrollPeriod){
            // Convert dateFrom to start of the day (00:00:00)
            const dateFrom = new Date(filteredPayrollPeriod.dateFrom);
            dateFrom.setHours(0, 0, 0, 0); // Set time to 00:00:00

            // Convert dateTo to the end of the day (23:59:59)
            const dateTo = new Date(filteredPayrollPeriod.dateTo);
            dateTo.setHours(23, 59, 59, 999); // Set time to 23:59:59.999

            finalData= allDTR.filter(item => {
                const itemDate = new Date(item.date); // Convert item.date to Date object
                return itemDate >= dateFrom && itemDate <= dateTo;
            });
        }

        setDateTimeRecordData(finalData);
        setFilterData(finalData);
    }, [filteredPayrollPeriod, allDTR]);
    //====================================================================================================
    //===============================TIME ENTRIES=========================================================
    //====================================================================================================

    return(
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TimeInfo">
                        <div className='sub-title row' style={{padding:"5px 20px"}}>
                            <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Time Keeping >"} </span>
                            <span style={{borderBottom:"1px solid black"}}>{"Tampered Approval"}</span>
                        </div>
                        <div className="timeHeader row" style={{justifyContent:"space-between", alignItems:"center"}}>
                            <div className="tHeaderTitle row">
                                <AccessTimeFilledIcon style={{padding:"0 10px 0 0"}}/>
                                <h3>Tampered Approval</h3>
                            </div>
                        </div>
                        <div className="mainData">
                            <UploadTimeEntries
                            allDTR={allDTR}
                            dateTimeRecordData={dateTimeRecordData} 
                            setDateTimeRecordData={setDateTimeRecordData}
                            // employees={employees}
                            isRevert={isRevert}
                            isProcess={isProcess}
                            isPost={isPost}
                            isDelete={isDelete}
                            isUpload={isUpload}
                            setIsRevert={setIsRevert}
                            setIsProcess={setIsProcess}
                            setIsPost={setIsPost}
                            setIsDelete={setIsDelete}
                            setIsUpload={setIsUpload}
                            selectedDTR={selectedDTR}
                            setSelectedDTR={setSelectedDTR}
                            activeRowIds={activeRowIds} 
                            setActiveRowIds={setActiveRowIds}
                            isSelectLogs={isSelectLogs}
                            setIsSelectLogs={setIsSelectLogs}
                            userAccess={userAccess}
                            user={user}
                            filterData={filterData}
                            fetchData={fetchDataTimeEntries}
                            sectionFilter={sectionFilter}
                            setSectionFilter={setSectionFilter}
                            locationFilter={locationFilter}
                            setLocationFilter={setLocationFilter}
                            filterClassificationId={filterClassificationIdTimeEntries}
                            setFilterClassificationId={setFilterClassificationIdTimeEntries}
                            filterClassificationId2={filterClassificationIdTimeEntries2}
                            setFilterClassificationId2={setFilterClassificationIdTimeEntries2}
                            filterClassificationId3={filterClassificationIdTimeEntries3}
                            setFilterClassificationId3={setFilterClassificationIdTimeEntries3}
                            filterPayrollPeriodId={filterPayrollPeriodId}
                            setFilterPayrollPeriodId={setFilterPayrollPeriodId}
                            filteredPayrollPeriod={filteredPayrollPeriod} 
                            setFilteredPayrollPeriod={setFilteredPayrollPeriod}
                            showTampered={showTampered} 
                            setShowTampered={setShowTampered}

                            filterDataIndex={filterDataIndex}
                            setFilterDataIndex={setFilterDataIndex}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {loadingRequest ?
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
                :
                <></>
            }
        </div>
    )
    
}

function UploadTimeEntries({
    allDTR,
    dateTimeRecordData,
    setDateTimeRecordData,
    setFetchUploads,
    employees,
    isRevert,
    isProcess,
    isPost,
    isDelete,
    isUpload,
    setIsRevert,
    setIsProcess,
    setIsPost,
    setIsDelete,
    setIsUpload,
    selectedDTR,
    setSelectedDTR,
    activeRowIds, 
    setActiveRowIds,
    openUploadTamperedFormHandleClick,
    isSelectLogs,
    setIsSelectLogs,
    userAccess,
    user,
    filterData,
    fetchData,
    sectionFilter,
    setSectionFilter,
    locationFilter,
    setLocationFilter,
    loading,
    filterClassificationId,
    setFilterClassificationId,
    filterClassificationId2,
    setFilterClassificationId2,
    filterClassificationId3,
    setFilterClassificationId3,
    filterPayrollPeriodId,
    setFilterPayrollPeriodId,
    filteredPayrollPeriod,
    setFilteredPayrollPeriod,
    showTampered,
    setShowTampered,
    filterDataIndex, setFilterDataIndex
}){
    var uploadTimeEntriesHeader = [
        "Id",
        "Employee Id",
        "Employee",
        "Classification",
        "Date",
        "Time In",
        "Device",
        "Time Out (Break)",
        "Device",
        "Time In (Break)",
        "Device",
        "Time Out",
        "Device",
        "Shift Name",
        "Reason for Tampering",
        "Approved?",
        "",
    ]
    var uploadTimeEntriesaccessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOutBreak",
        "deviceNameTimeOutBreak",
        "timeInBreak",
        "deviceNameTimeInBreak",
        "timeOut",
        "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
        "reasonForTampering",
        "isApproved",
        "manage"
    ]

    const [approveMessage, setApproveMessage] = useState(false);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationEmployeeId, setEmployeePersonalInformationEmployeeId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [date, setDate] = useState("");
    const [timeIn, setTimeIn] = useState("");
    const [deviceNameTimeIn, setDeviceNameTimeIn] = useState("");
    const [timeOut, setTimeOut] = useState("");
    const [deviceNameTimeOut, setDeviceNameTimeOut] = useState("");
    const [reasonForTampering, setReasonForTampering] = useState("");
    //Old
    const [oldTimeIn, setOldTimeIn] = useState("");
    const [oldDeviceNameTimeIn, setOldDeviceNameTimeIn] = useState("");
    const [oldTimeOut, setOldTimeOut] = useState("");
    const [oldDeviceNameTimeOut, setOldDeviceNameTimeOut] = useState("");
    const [oldReasonForTampering, setOldReasonForTampering] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [dataToDelete, setDataToDelete] = useState([]);
    //Approve
    const [showApproveForm, setShowApproveForm] = useState(false);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const handleClickShowTampered = () =>{
        if(dateTimeRecordData.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No Time Entries yet.");
            return;
        }

        setShowTampered(!showTampered);
    }

    const apiUrl =  domain + "/api/EmployeeTimeRecord";

    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeePersonalInformationEmployeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setDateTimeRecordData(res);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            date: timeIn.split('T')[0],
            createdById: user.id,
            createdDate: new Date(),
        };

        try {
            setShowAddForm(false); // Hide the add form
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "inser", 
                field: "Add", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationFullName("");
            setTimeIn("");
            setDeviceNameTimeIn("");
            setTimeOut("");
            setDeviceNameTimeOut("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            employeePersonalInformationEmployeeId: employeePersonalInformationEmployeeId,
            date: date,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            reasonForTampering: reasonForTampering,
            createdById: dataToEdit.createdById,
            createdDate: dataToEdit.createdDate,
            updatedById: user.id,
            updatedDate: new Date()
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${dataToEdit.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.timeIn !== oldTimeIn){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Time In",
                    newValue: `${data.timeIn}`,
                    oldValue: `${oldTimeIn}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.deviceNameTimeIn !== oldDeviceNameTimeIn){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Device Time In",
                    newValue: `${data.deviceNameTimeIn}`,
                    oldValue: `${oldDeviceNameTimeIn}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.timeOut !== oldTimeOut){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Time Out",
                    newValue: `${data.timeOut}`,
                    oldValue: `${oldTimeOut}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.deviceNameTimeOut !== oldDeviceNameTimeOut){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Device Time Out",
                    newValue: `${data.deviceNameTimeOut}`,
                    oldValue: `${oldDeviceNameTimeOut}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.reasonForTampering !== oldReasonForTampering){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Reason for Tampering",
                    newValue: `${data.reasonForTampering}`,
                    oldValue: `${oldReasonForTampering}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `/${dataToDelete.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowDeleteForm(false);
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "delete", 
                field: "Delete Time Entry", 
                newValue: `-`, 
                oldValue: `${dataToDelete.employeePersonalInformationFullName}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setDataToDelete("");
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteForm(false);
    };
    const approveHandleClick = async () => {
        if (selectedDTR.length <= 0) {
            setApproveMessage(true);
            setRequestMessage("No selected record");
            setIsSuccess(false);
            closeApproveHandleClick();
            return;
        }
        
        setLoadingRequest(true);
        setShowApproveForm(false);

        try {
            await axios.put(apiUrl + `/approval-bulk`, selectedDTR, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Updated successfully');
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "update", 
                field: "Approve", 
                newValue: "Approved", 
                oldValue: "Pending", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            // Reload table data and reset state
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setLoadingRequest(false);
            setSelectedDTR([]);
            setActiveRowIds([]);
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating record:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationEmployeeId(dataToEdit.employeePersonalInformationEmployeeId)
            setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
            setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName)
            setTimeIn(dataToEdit.timeIn)
            setDate(dataToEdit.date)
            setDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
            setTimeOut(dataToEdit.timeOut)
            setDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
            setReasonForTampering(dataToEdit.reasonForTampering)
            setOldTimeIn(dataToEdit.timeIn)
            setOldDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
            setOldTimeOut(dataToEdit.timeOut)
            setOldDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
            setOldReasonForTampering(dataToEdit.reasonForTampering)
        }
    }, [showEditForm, 
        dataToEdit, 
    ]);

    const editHandleClick = (data) => {
        setDataToEdit(data);
        setShowEditForm(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDataToDelete(data);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeApproveHandleClick = () => {
        setShowApproveForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };
    
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [showRequestMessage]);

    useEffect(() => {
        if (approveMessage) {
            const timeoutId = setTimeout(() => {
                setApproveMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [approveMessage]);

    return(
        <>
            <div style={{padding:"10px"}}>
                <div className='filters-payroll'>
                    <span>Filter</span>
                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "unset"}}>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId}
                                    filteredPayrollPeriod={filteredPayrollPeriod} setFilteredPayrollPeriod={setFilteredPayrollPeriod}
                                />
                            </div>
                        </div>
                        { userAccess && (userAccess?.description === "Admin" || userAccess?.description === "HR Head" || userAccess?.description === "HR Assistant") && 
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Classification Type</div>
                                <div className="info-item-input">
                                    <ClassificationIdSelectWithAll1 classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} setActiveRowIds={setActiveRowIds} setSelectedDTR={setSelectedDTR}/>
                                </div>
                            </div>
                        }
                        { userAccess && (userAccess?.description === "HR Assistant2") && 
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Classification Type</div>
                                <div className="info-item-input">
                                    <ClassificationIdSelectWithAll2 classificationId={filterClassificationId2} setClassificationId={setFilterClassificationId2} setActiveRowIds={setActiveRowIds} setSelectedDTR={setSelectedDTR}/>
                                </div>
                            </div>
                        }
                        { userAccess && (userAccess?.description === "HR Assistant3") && 
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Classification Type</div>
                                <div className="info-item-input">
                                    <ClassificationIdSelectWithAll3 classificationId={filterClassificationId3} setClassificationId={setFilterClassificationId3} setActiveRowIds={setActiveRowIds} setSelectedDTR={setSelectedDTR}/>
                                </div>
                            </div>
                        }
                        { userAccess.length <= 0 && 
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Classification Type</div>
                                <div className="info-item-input">
                                    <ClassificationIdSelectWithAllDummy/>
                                </div>
                            </div>
                        }
                        { (filterClassificationId.toString() === "3" || filterClassificationId2.toString() === "3") &&
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Section</div>
                                <div className="info-item-input">
                                    <SectionIdSelect sectionId={sectionFilter} setSectionId={setSectionFilter}/>
                                </div>
                            </div>
                        }
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                            </div>
                        </div>
                    </div>
                    {/* <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div> */}
                </div>
            </div>
            <div className="mainte-body-top row">
                    {Filter(setFilterDataIndex)}
            </div>
            <div className="mainte-body-top row timeEntries-search-div" style={{justifyContent: "space-between"}}>
                <>
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by name", 
                                                    SearchIcon)}
                </>
                <div className="timeBtns row" style={{padding: "0"}}>
                    { !showTampered ?
                        <div className="timeBtn extract row" style={{display: "none"}}>
                            {CreateButton("", "icon row", handleClickShowTampered, "SHOW TAMPERED ONLY", VisibilityOffIcon)}
                        </div>
                        :
                        <div className="timeBtn extract row" style={{display: "none"}}>
                            {CreateButton("", "icon row", handleClickShowTampered, "SHOW ALL ENTRIES", RemoveRedEyeIcon)}
                        </div>
                    }
                    <div className="timeBtn approve row">
                        {CreateButton("", "icon row", ()=>setShowApproveForm(true), "APPROVE", DoneIcon)}
                    </div>
                    <div className="timeBtn approve row">
                        {CreateButton("", "icon row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                    </div>
                </div>
            </div>
            <div className="timeTable container">
                <CreateTable
                    dataList={dateTimeRecordData}
                    dataHeader={uploadTimeEntriesHeader}
                    dataAccessor={uploadTimeEntriesaccessor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    setSelected={setSelectedDTR}
                    isSelectAll={isSelectAll}
                    setIsSelectAll={setIsSelectAll}
                    activeRowIds={activeRowIds}
                    setActiveRowIds={setActiveRowIds}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {dateTimeRecordData.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    reasonForTampering={reasonForTampering}
                    setReasonForTampering={setReasonForTampering}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <ApproveForm  isOpen={showApproveForm} 
                    onClose={closeApproveHandleClick}
                    handleApprove={approveHandleClick}
            >
            </ApproveForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    userAccessData={userAccess}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateMessage form={approveMessage}
                    message={requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    )
}
function AddForm({
    isOpen, 
    onClose,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
        || !timeIn
        // || !deviceNameTimeIn
        || !timeOut
        // || !deviceNameTimeOut
    ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    reasonForTampering,
    setReasonForTampering,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
            || !timeIn
            // || !deviceNameTimeIn
            || !timeOut
            // || !deviceNameTimeOut
            || !reasonForTampering
        ){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setReasonForTampering("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        style={{cursor:"not-allowed"}}
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason For Tampering</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonForTampering}
                                        onChange={(e)=>setReasonForTampering(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !reasonForTampering && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ApproveForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approval!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected record/s?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                APPROVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function EditBtn(cell)
{
    var editTabHolder = document.getElementById("editTabHolder")
    if(editTabHolder !== null){
        editTabHolder.style.display = "block";
    }

    var employee = document.getElementById("employeeEdit");
    var timeIn = document.getElementById("datetime-in-edit");
    var timeOut = document.getElementById("datetime-out-edit");
    var timeInDevice = document.getElementById("timeInDevEdit");
    var timeOutDevice = document.getElementById("timeOutDevEdit");
    employee.value = cell.employee;
    timeIn.value = cell.date + "T" + cell.timeIn;
    timeOut.value = cell.date + "T" + cell.timeOut;
    timeInDevice.value = cell.timeInDevice;
    timeOutDevice.value = cell.timeOutDevice;
};
function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId, filteredPayrollPeriod, setFilteredPayrollPeriod}){
    const [data, setData] = useState([]);

    const handleSelectChange = (event) => {
        setPayrollPeriodId(event.target.value);

        const foundPayrollPeriod = data.find(_data => _data.id.toString() === event.target.value.toString());
        setFilteredPayrollPeriod(foundPayrollPeriod);
    };

    const fetchData = async () => {
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`;

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="">All</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function ClassificationIdSelectWithAllDummy(){
    return (
        <div>
            <select id="employee-select-PagibigReport">
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll1({classificationId, setClassificationId, setActiveRowIds, setSelectedDTR}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedDTR){
            setActiveRowIds([]);
            setSelectedDTR([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose classification</option>
                {data.length > 0 && <option value="0">All</option>}
                {data.map((classificationId) => ( 
                    SetClassificationId(classificationId)
                ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll2({classificationId, setClassificationId, setActiveRowIds, setSelectedDTR}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedDTR){
            setActiveRowIds([]);
            setSelectedDTR([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                {data.map((classificationId) => ( 
                    <React.Fragment key={classificationId.id}>
                        {classificationId.id === 2 && (
                            SetClassificationId(classificationId)
                        )}
                        {classificationId.id === 3 && (
                            SetClassificationId(classificationId)
                        )}
                    </React.Fragment>
                ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll3({classificationId, setClassificationId, setActiveRowIds, setSelectedDTR}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedDTR){
            setActiveRowIds([]);
            setSelectedDTR([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                {data.map((classificationId) => ( 
                    <React.Fragment key={classificationId.id}>
                        {classificationId.id === 4 && (
                            SetClassificationId(classificationId)
                        )}
                    </React.Fragment>
                ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function SectionIdSelect({sectionId, setSectionId}){
    
    const handleSelectChange = (event) => {
        setSectionId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option value={sectionId.id}>{
            sectionId.description}
        </option>
    )
    
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    userAccessData
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesInfo, setEmployeesInfo] = useState([]);
    const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("0");
    const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] = useState("2");
    const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] = useState("4");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    const fetchDataAllData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/active";
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all";
        setEmployees([]);
        setFilterData([]);

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                const employeeAllData = await fetchDataAllData();
                setEmployeesInfo(employeeAllData);
                setAllEmployeesBasicInfo(response.data);
                setEmployees(response.data);
                setFilterData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [fetchDataAllData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(()=>{
        let classifiedData = allEmployeesBasicInfo;
        let classificiationFilter = classificationFilterForAdminHRHead;

        if(userAccessData){
            if(userAccessData.description === "Admin" || userAccessData.description === "HR Head" || userAccessData.description === "HR Assistant"){
                classificiationFilter = classificationFilterForAdminHRHead;
            } else if(userAccessData.description === "HR Assistant2"){
                classificiationFilter = classificationFilterForHRAsst2;
            } else if(userAccessData.description === "HR Assistant3"){
                classificiationFilter = classificationFilterForHRAsst3;
            }
        }

        setCurrentClassificationFilter(classificiationFilter);

        if(classificiationFilter !== "0" && classificiationFilter !== "All"){
            const _classified = allEmployeesBasicInfo.filter(employee => {
                const foundEmployee = employeesInfo.find(_employee => _employee.employeeId === employee.employeeId);
                
                if (foundEmployee.employeeInformation && foundEmployee.employeeInformation.classificationId) {
                    return foundEmployee.employeeInformation.classificationId.toString() === classificiationFilter;
                }
                return false;
            });
            
            classifiedData = _classified;
        }

        if(classificiationFilter !== currentClassificationFilter){
            setEmployees(classifiedData);
            setFilterData(classifiedData);
        }
    }, [
        classificationFilterForAdminHRHead, 
        classificationFilterForHRAsst2, 
        classificationFilterForHRAsst3,
        currentClassificationFilter,
        employees,
        employeesInfo,
        allEmployeesBasicInfo,
        userAccessData
    ])

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [fetchData, filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="transaction-body" style={{padding: "0 20px"}}>
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Filter</div>
                                        <div className="info-item-input">
                                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                                        </div>
                                    </div>
                                    {userAccessData.length <= 0 && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAllDummy/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && (userAccessData.description === "Admin" || userAccessData.description === "HR Head" || userAccessData.description === "HR Assistant") && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAll1 classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead}/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && userAccessData.description === "HR Assistant2" && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAll2 classificationId={classificationFilterForHRAsst2} setClassificationId={setClassificationFilterForHRAsst2}/>
                                            </div>
                                        </div>
                                    }
                                    {userAccessData && userAccessData.description === "HR Assistant3" && 
                                        <div className="filter-item-payroll popUp-item info-item column">
                                            <div className="info-item-label">Classification Type</div>
                                            <div className="info-item-input">
                                                <ClassificationIdSelectWithAll3 classificationId={classificationFilterForHRAsst3} setClassificationId={setClassificationFilterForHRAsst3}/>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            {/* <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/> */}
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
        </select>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeDevice({device, setDevice}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDevice(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Device";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(device !== "" && device !== 0 && device !== null && device !== undefined){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [device]);

    return (
        <div>
            <select id="" className="filterSelect" value={device} onChange={handleSelectChange} style={{color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a device</option>
                {data.map((device) => ( 
                    SetTimeDevice(device)
                ))}
            </select>
        </div>
    );
};
function SetTimeDevice(device){
    return(
        <option value={device.name}>{
            device.name}
        </option>
    )
}
function GenerateMessage({form, message, isSuccess}){
    return (
        <>
            <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                    <div className='column'>
                        {isSuccess ?
                            <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                <CheckCircleIcon/>
                                <span >{"SUCCESS MESSAGE"}</span>
                            </div>
                            :
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"ERROR MESSAGE"}</span>
                            </div>
                        }
                        <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({
    dataList = [],
    dataHeader = [],
    dataAccessor = [],
    currentPage,
    setCurrentPage,
    editHandleClick,
    deleteHandleClick,
    setSelected,
    employees,
    isSelectAll,
    setIsSelectAll,
    activeRowIds,
    setActiveRowIds
}) {
    const itemsPerPage = 10;

    // Define table columns
    const columns = React.useMemo(
        () =>
            dataHeader.map((header, index) => ({
                Header: header,
                accessor: dataAccessor[index],
            })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Select all logic
    useEffect(() => {
        if (isSelectAll) {
            const newActiveRowIds = rows.map((item) => item.original.id);
            const newActiveRowOriginal = rows.map((item) => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelected(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelected, rows, setActiveRowIds]);

    // Row click handler
    const handleRowClick = (rowData) => {
        setSelected((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (item) => item.id === rowData.id
            );
            return isAlreadySelected
                ? prevSelected.filter((item) => item.id !== rowData.id)
                : [...prevSelected, rowData];
        });

        setActiveRowIds((prevIds) =>
            prevIds.includes(rowData.id)
                ? prevIds.filter((id) => id !== rowData.id)
                : [...prevIds, rowData.id]
        );
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className="scrollable-table">
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        onClick={() => headerClick(column)}
                                        className="sortable-header"
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row);
                            return (
                                <tr
                                    key={row.original.id}
                                    {...row.getRowProps()}
                                    onClick={() =>
                                        handleRowClick(row.original)
                                    }
                                    className={
                                        activeRowIds.includes(row.original.id)
                                            ? "active"
                                            : ""
                                    }
                                    id={
                                        row.original.reasonForTampering
                                            ? "tampered"
                                            : ""
                                    }
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo
                                            header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                        />
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {rows.length > itemsPerPage ? (
                <>
                    <div
                        className="table-page row"
                        style={{
                            alignItems: "center",
                            justifyContent: "end",
                            padding: "20px 0 0 0",
                        }}
                    >
                        <button
                            className="prev row"
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            &lt;&lt;
                        </button>
                        <button
                            className="prev row"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            PREVIOUS
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            NEXT
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(totalPages)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                height: "26px",
                            }}
                        >
                            &gt;&gt;
                        </button>
                    </div>
                    {`${currentPage}/${totalPages}`}
                </>
            ) : (
                <></>
            )}
        </>
    );
}
export function CreateTableWithHeaderDragSummary({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, setSelected, employees, handleDragStart, filteredHeaderForSummary }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [updatedDataHeader, setUpdatedDataHeader] = useState(dataHeader);
    const [updatedDataAccessor, setUpdatedDataAccessor] = useState(dataAccessor);

    useEffect(() => {
        let itemsToRemove = [];
        
        if (filteredHeaderForSummary && filteredHeaderForSummary.length > 0) {
            itemsToRemove = filteredHeaderForSummary.map(item => item.textContent);
        }
        
        const removedItemIndexes = [];
        const newUpdatedDataHeader = dataHeader.filter((item, index) => {
            if (itemsToRemove.includes(item)) {
                removedItemIndexes.push(index);
                return false; // Exclude the item from the filtered array
            }
            return true; // Include the item in the filtered array
        });
        const newDataAccessor = dataAccessor.filter((_, index) => !removedItemIndexes.includes(index));
        setUpdatedDataHeader(newUpdatedDataHeader);
        setUpdatedDataAccessor(newDataAccessor);
    }, [dataHeader, dataAccessor, filteredHeaderForSummary]);

    const columns = React.useMemo(() =>
        updatedDataHeader.map((header, index) => ({
            Header: header,
            accessor: updatedDataAccessor[index]
        })),
        [updatedDataHeader, updatedDataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className='scrollable-table'>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}
                                    className='draggable-header sortable-header'
                                    draggable
                                    onDragStart={(e)=>handleDragStart(e, column.render("Header"))}
                                    onClick={() => headerClick(column)}
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
export function CreateTableWithHeaderDragDetailed({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, setSelected, employees, handleDragStart, filteredHeaderForDetailed }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [updatedDataHeader, setUpdatedDataHeader] = useState(dataHeader);
    const [updatedDataAccessor, setUpdatedDataAccessor] = useState(dataAccessor);

    useEffect(() => {
        let itemsToRemove = [];
        
        if (filteredHeaderForDetailed && filteredHeaderForDetailed.length > 0) {
            itemsToRemove = filteredHeaderForDetailed.map(item => item.textContent);
        }
        
        const removedItemIndexes = [];
        const newUpdatedDataHeader = dataHeader.filter((item, index) => {
            if (itemsToRemove.includes(item)) {
                removedItemIndexes.push(index);
                return false; // Exclude the item from the filtered array
            }
            return true; // Include the item in the filtered array
        });
        const newDataAccessor = dataAccessor.filter((_, index) => !removedItemIndexes.includes(index));
        setUpdatedDataHeader(newUpdatedDataHeader);
        setUpdatedDataAccessor(newDataAccessor);
    }, [dataHeader, dataAccessor, filteredHeaderForDetailed]);

    const columns = React.useMemo(() =>
        updatedDataHeader.map((header, index) => ({
            Header: header,
            accessor: updatedDataAccessor[index]
        })),
        [updatedDataHeader, updatedDataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className='scrollable-table'>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}
                                    className='draggable-header sortable-header'
                                    draggable
                                    onDragStart={(e)=>handleDragStart(e, column.render("Header"))}
                                    onClick={() => headerClick(column)}
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
export function CreateTableForEmployeeSelect({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, setSelectedEmployee}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleRowClick = (rowData) => {
        setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    };

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header} 
                                        _cell={cell}/>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px"}}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px"}}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div style={{textAlign:"center"}}>{`${currentPage}/${totalPages}`}</div>
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    /* if (header === "Device") {
        return (
            <td></td>
        )
    } */

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    || header === "Time In (Break)"
    || header === "Time Out (Break)"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('Unapproved');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    };

    useEffect(() => {
        switch (selectedOption) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "EmployeeName":
                setFilterDataIndex(2);
                break;
            case "Approved":
                setFilterDataIndex(3);
                break;
            case "Unapproved":
                setFilterDataIndex(4);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    }, [selectedOption, setFilterDataIndex])

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
                <option value="EmployeeName">Employee Name</option>
                <option value="Approved">Approved</option>
                <option value="Unapproved">Unapproved</option>
            </select>
        </div>
    );
};
export default TamperedApproval
